'use client'

import { useVaultRoute } from '@/components/VaultPage/components/VaultRoute'
import { RiskDisclosureLoading } from '@/components/VaultPage/VaultV1/VaultRiskDisclosures/RiskDisclosure/states'

import VaultV2RiskDisclosuresClient from '../VaultV2RiskDisclosures.client'
import VaultV2RiskDisclosuresLayout from '../VaultV2RiskDisclosures.layout'

/**
 * The disclosure comes from static config, so the route loader can render the resolved
 * vault's real text, at its real height, before the page streams.
 */
const VaultV2RiskDisclosuresRouteLoading = () => {
  const route = useVaultRoute()

  return (
    <VaultV2RiskDisclosuresLayout>
      {route ? (
        <VaultV2RiskDisclosuresClient chainId={route.chainId} vaultAddress={route.address} />
      ) : (
        <RiskDisclosureLoading />
      )}
    </VaultV2RiskDisclosuresLayout>
  )
}

export default VaultV2RiskDisclosuresRouteLoading
